import { useEffect, useState } from "react";
import "./cascader.css";
// import { Container, Level } from "./Cascader.styled";
import iconArrow from "src/assets/arrow_down.png";
import ClickOutside from "../common/ClickOutside";
import { TextField } from "@mui/material";

const Cascader = ({ kiLabel = "label", kiValue = "id", options, defaultValue, onNodeClick, onSelect = () => {}, children, level = 3, ...props }) => {
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [levels, setLevels] = useState([options || []]);
  const [selects, setSelects] = useState([]);
  const [text, setText] = useState('');

  // console.log(levels);

  useEffect(() => {
    if (!defaultValue) return;
    setText(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (levels.length) return;
    setLevels([JSON.parse(JSON.stringify(options)) || []]);
  }, [options]);

  function handleItemClick(item, levelIdx) {
    if (levelIdx !== 0 && levels[levelIdx + 1] && item[kiValue] === levels[levelIdx][kiValue]) return;

    // console.log(item)
    if (!item.children) {
      console.log("选到头了");
      const _selects = [...selects];
      // _selects[levelIdx] = item[kiValue];
      _selects[levelIdx] = { label: item[kiLabel], value: item[kiValue] };
      setSelects(_selects.slice(0, levelIdx + 1));

      onSelect(_selects.slice(0, levelIdx + 1));

      setText(_selects.map(s => s.label).join('/'))

      setOpen(false);
      return;
    }

    const _levels = [...levels];
    _levels[levelIdx + 1] = item.children;
    setLevels(_levels.slice(0, levelIdx + 2));

    const _selects = [...selects];
    _selects[levelIdx] = { label: item[kiLabel], value: item[kiValue] };

    onNodeClick && onNodeClick(levelIdx, _selects[levelIdx]);
    setSelects(_selects.slice(0, levelIdx + 1));

    // 如果就2层
    console.log(item, levelIdx)
    if (level == 2 && levelIdx == 1) {
      onSelect(_selects.slice(0, levelIdx + 1));
      setOpen(false);
      return;
    }
  }

  // console.log(selects);

  function renderLevels() {
    if (!levels) return null;

    return levels.map((level, levelIdx) => {
      return (
        <div className="cascader-level" key={levelIdx}>
          {level.map((item, itemIdx) => (
            <div className={`rcsb cascader-level-item ${selects[levelIdx] && selects[levelIdx].value === item[kiValue] ? "active" : ""}`} key={itemIdx} onClick={() => handleItemClick(item, levelIdx)}>
              {item[kiLabel]}
              {item.children ? <img src={iconArrow} /> : null}
            </div>
          ))}
        </div>
      );
    });
  }

  return (
    <ClickOutside onClickOutside={() => setOpen(false)} style={{position: 'relative'}}>
      <TextField disabled={disabled} size="small" value={text} onFocus={() => {
        setOpen(true)
      }} />
      {open && (
        <div className="rc cascader-container" {...props}>
          {renderLevels(options)}
        </div>
      )}
    </ClickOutside>
  );
};

export default Cascader;
